import { _updateCartHTML } from '../../Cart/functions/_updateCartHTML';
import { _addItem } from '../../Shopify/functions/_addItem';
import { _getCart } from '../../Shopify/functions/_getCart';
import {_show} from '../../Modals/functions/_show';

/**
 * Add support for ajax 'add-to-cart'.
 */
export const _submitForm = () => {

	const elements = {
		form: document.querySelector('form[action="/cart/add"]'),
		addToCart: document.querySelectorAll('.js-add-to-cart'),
		cartCounters: document.querySelectorAll('.js-cart-count'),
		submitButton: document.querySelector('form[action="/cart/add"] button[type="submit"]'),
	};

	if (!elements.form) {
		return;
	}

	elements.form.addEventListener('submit', (e) => e.preventDefault());

	if (elements.addToCart.length) {
		elements.addToCart.forEach(button => {
			button.addEventListener('click', (e) => {
				onSubmit(e, elements)
			})
		}
		);
	}
}

const onSubmit = (e, elements = {}) => {

	const variantID = elements.form.querySelector('input[name="id"]').value;
	const button = e.target.closest('.js-add-to-cart');

	if (variantID) {

		const quantity = parseInt(elements.form.querySelector('[name="quantity"]').value);

		_addItem(variantID, quantity)
			.then((res) => {
				if (elements.submitButton) {
					button.disabled = true;
					button.classList.add('is-adding');
					button.innerHTML = `<span class="c-button__label">ADDING</span>`;

					setTimeout(() => {
						button.classList.remove('is-adding');
						button.disabled = false;
						button.innerHTML = `<span class="c-button__label">ADD TO CART</span>`;
					}, 1000);
				}

				_getCart()
					.then((cart) => {
						_updateCartHTML(cart);
						_show(document.getElementById('cart-modal'));
					})

			})
			.catch(err => console.log('Error', err))
	}
}
